// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader__header___1FkN_"};